import { get, internalDestroy, internalPost, internalPut } from '.';
import qs from 'qs';

export const getFacilities = ({ filters }) => {
  return get(`/facilities?${qs.stringify(filters)}`);
};

export const getFacility = ({ facilityId, locale }) => {
  return get(`/facilities/${facilityId}?locale=${locale}`);
};

export const createFacility = ({ payload, locale }) => {
  return internalPost(`/facilities?locale=${locale}`, payload);
};

export const updateFacility = ({ facilityId, payload, locale }) => {
  return internalPut(`/facilities/${facilityId}?locale=${locale}`, payload);
};

export const deleteFacility = ({ facilityId, payload }) => {
  return internalDestroy(`/facilities/${facilityId}`, payload);
};
